import classNames from "classnames";
import { usePrice } from "@hooks/use-prices";
import Badge from "@components/core/Badge/Badge";
import useFeatures from "@hooks/use-features";

const ProductPriceSection = ({ product, hideDiscountPercent, className }) => {
  const features = useFeatures();
  const price = usePrice();

  const priceDiff = product.retail_price - product.current_price;
  const calculatedDiscountPercent = Math.round((priceDiff / product.retail_price) * 100);
  const displayDiscountBadge = calculatedDiscountPercent > features.min_discount_to_display;

  return (
    <div className={classNames("d-flex align-items-center flex-start flex-wrap font-size-sm", className)}>
      {!hideDiscountPercent && displayDiscountBadge && (
        <Badge variant="primary" className="me-2">
          -
          {calculatedDiscountPercent}
          %
        </Badge>
      )}
      <p className="font-weight-bold font-size-sm mb-0 me-2">{price(product.current_price, {withoutSpace: true})}</p>
      <p className="font-size-sm strike-price text-gray mb-0">{price(product.retail_price, {withoutSpace: true })}</p>
    </div>
  );
};

export default ProductPriceSection;
